export const distinctiveunexpected = {
  name: 'Distinctive & Unexpected',
  color: [0.6941176470588235, 0.8431372549019608, 0.8235294117647058, 1],
  bg: [0.3568627450980392, 0.7843137254901961, 0.6745098039215687, 1],
  grid1: [0.2627450980392157, 0.1803921568627451, 0.2, 1],
  grid2: [0.9058823529411765, 0.2784313725490196, 0.1803921568627451, 1],
}
